import { getMessageLifetime } from '@js/interface-utils'


const getDefaultState = () => {
  return {
    message: '',
    timerId: null,
    warning: '',
  };
};

const notification = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    clear (state) {
      state.message = '';
      state.warning = '';
      clearTimeout(state.timerId);
      state.timerId = null;
    },
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
    setMessage (state, message) {
      state.warning = '';
      state.message = message;
      clearTimeout(state.timerId);

      const interval = getMessageLifetime(message.length, false);

      state.timerId = setTimeout(() => {
        state.message = '';
      }, interval);
    },
    setWarning (state, message) {
      state.warning = message;
      state.message = '';
      clearTimeout(state.timerId);

      const interval = getMessageLifetime(message.length, true);

      state.timerId = setTimeout(() => {
        state.warning = '';
      }, interval);
    },
  },
};

export default notification;
